import { useEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { UserRoutes } from "./UserRoutes";
import { PageRoutes } from "./PageRoutes";
import { checkToken } from "../apis";
import { useDispatch } from "react-redux";
import { startLoggedOut } from "../store/auth/authThunks";
// import { ModalKeepSessionAlive } from "../components/Modal/ModalKeepSessionAlive";
import { setFromUrl } from "../store/jaguar/jaguarSlice";
import { Loading } from "../components/Loading/String/Loading";

export const AppRouter = () => {
  const { isLoggedIn, tenant, status } = useSelector((state) => state.auth);
  const session = JSON.parse(localStorage.getItem("Session")) || null;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  // El regreso del SSO trae un código que reemplaza la sesión que hubiera
  // abierta: se atiende siempre en PageRoutes (AuthCallback), aunque ya haya
  // sesión con tenant, y no se valida la sesión anterior, porque si estaba
  // vencida su logout podría llegar después del canje y borrar la nueva.
  const isSsoCallback = location.pathname === "/auth-callback";

  useEffect(() => {
    if (isSsoCallback) return;
    const idToken = session?.IdToken;
    const accessToken = session?.AccessToken;
    if (idToken && accessToken) {
      checkToken(idToken, accessToken)
        .then(() => {
          // console.log("Valid credentials")
        })
        .catch(() => {
          dispatch(startLoggedOut());
          navigate("/");
        });
    } else {
      dispatch(startLoggedOut());
      navigate("/");
    }
  }, []);

  // Verificar si se accede a la pagina desde una url en especifico
  useEffect(() => {
    const { pathname } = location;
    // /auth-callback no es un destino: UserRoutes volvería a él al entrar.
    if (pathname !== "/" && !isSsoCallback) {
      dispatch(setFromUrl(pathname));
    }
  }, []);

  useEffect(() => {
    if (isLoggedIn && tenant && location.pathname === "/login") {
      navigate("/dashboard", { replace: true });
    }
  }, [isLoggedIn, tenant]);

  if (status === "checking") {
    return <Loading />;
  }

  return (
    <>
      {/* <ModalKeepSessionAlive /> */}
      <Routes>
        {isLoggedIn && tenant && !isSsoCallback ? (
          <Route path="/*" element={<UserRoutes />} />
        ) : (
          <Route path="/*" element={<PageRoutes />} />
        )}
      </Routes>
    </>
  );
};
